module.exports = __webpack_public_path__ + "static/media/store_code.51c1f730.jpg";